import { defineComponent } from 'vue';
import { IonImg } from "@ionic/vue";
export default defineComponent({
    name: 'PageTitle',
    components: { IonImg },
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        iconImage() {
            // const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
            // const theme = prefersDark.matches ? 'dark' : 'light';
            return new URL('@/assets/png/campus_icon.png', import.meta.url).href;
            // return require(`@/assets/svg/logo-theme-${theme}.svg`)
        }
    }
});
